const filterByTags = {
    element: $('.js-filter-modal'),
    tagsContainer: $('.js-filter-tags-container'),
    notFound: $('.js-filter-not-found'),
    classes: {
        searchButton: 'js-filter-search-button',
        searchInput: 'js-filter-search-input',
        tagLabel: 'js-filter-tag-label',
        tag: 'js-filter-tag',
        hidden: 'visually-hidden'
    },

    init: function () {
        this.initInputListener();
    },

    initInputListener: function () {
        this.search.on('input', this.onInputChange.bind(this));
    },

    get searchButton() {
        return $(`.${this.classes.searchButton}`);
    },

    get search() {
        return $(`.${this.classes.searchInput}`);
    },

    onInputChange: function () {
        this.toggleTags();
        this.toggleTagsContainer();

        if (!this.checkTagsHidden(this.element))
            this.showNotFoundMessage();
        else
            this.hideNotFoundMessage();
    },

    toggleTags: function () {
        const tags = this.tagsContainer.find(`.${this.classes.tag}`)
        $(tags).each((key, item) => {
            const checkboxLabel = $(item).find(`.${this.classes.tagLabel}`).text().toLowerCase();
            const searchValue = this.search.val().toLowerCase();
            $(item).toggleClass(this.classes.hidden, !checkboxLabel.includes(searchValue));
        })
    },

    toggleTagsContainer: function () {
        $(this.tagsContainer).each((key, item) => {
            $(item).toggleClass(this.classes.hidden, !this.checkTagsHidden(item));
        })
    },

    checkTagsHidden: function (container) {
        return !!$(container).find(`.${this.classes.tag}:not(.${this.classes.hidden})`).length;
    },

    showNotFoundMessage: function () {
        $(this.notFound).text(`По запросу «${this.search.val()}» ничего не найдено, попробуйте изменить запрос.`);
        $(this.notFound).removeClass(this.classes.hidden);
    },

    hideNotFoundMessage: function () {
        $(this.notFound).text(' ');
        $(this.notFound).addClass(this.classes.hidden);
    },

};

filterByTags.init();